export const numOrUndef = (value: unknown): number | undefined =>
  typeof value === 'number' ? value : undefined;

export const strOrUndef = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;
